/**
 * <DefaultTab
 *		// please describe props here
 *	/>
 *
 * This is ...
 *
 * @parent anybody
 * @children
 * @stateful
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { hotline } from 'vendor/react-redux-hotline';
//
import StudentTable from './StudentTable'
import { confirm } from "util/confirm";
import { PanelCurtain } from 'components/UI/PanelWrapper'

// controllers
import searchStudentSummary from "controllers/student/searchStudentSummary";
import tableSettingsFactory from "./table-settings";
import studentFieldsFactory from './student-table-field';

import enrollStudentToClass from './enroll-student-to-class';
import exitClass from './exit-class';
import refund from './refund';
import archiveStudent from './archive-student';
import unarchiveStudent from './unarchive-student';
import payment from './payment';

import OnBoardingNatural from 'template/OnBoardingNatural';

import Loading from 'components/UI/Loading';

import { SHOW_CLASSES_UPTO_NUMBER_OF } from './constants';
import { onBoardingContents } from './constants';

import { FIRST_PAGE, ITEMS_COUNT_PER_PAGE } from './constants';

class DefaultTab extends React.Component {
  constructor(props) {
    super(props);

    this.unarchiveStudent = unarchiveStudent.bind(this);
    this.refund = refund.bind(this);
    this.exitClass = exitClass.bind(this);
    this.archiveStudent = archiveStudent.bind(this);
    this.enrollStudentToClass = enrollStudentToClass.bind(this);
    this.payment = payment.bind(this);

    this._settingsModifier = this._settingsModifier.bind(this);
    this._onTrSelectionToggled = this._onTrSelectionToggled.bind(this);
    this._onPageChange = this._onPageChange.bind(this);
    this._onItemsCountPerPageChange = this._onItemsCountPerPageChange.bind(this);

    this.state = {
      expandedClassInfos: {
        // [student.schoolStudentID]: true <-- if true which means 'the collapsed school classes'
        // are expanded and all shown
      }
		}

	}

  static propTypes = {
    // studentState is one of [current, not_enrolled, enrolled, pending_renewal, archived]
    studentState: PropTypes.string.isRequired
	}

  componentWillMount() {
    let { studentState, orderBy } = this.props;

    this.props.student.setStudentState('@constructor @DefaultTab', studentState);

    this.collapseRows = this.collapseRows.bind(this);
    this.tableSettings = tableSettingsFactory.call(this, studentState);
    this.studentFields = studentFieldsFactory.call(this, studentState);

    this.props.student.fetchStudent('@componentWillMount() @DefualtTab', studentState, {
      activePage: FIRST_PAGE,
      itemsCountPerPage: ITEMS_COUNT_PER_PAGE,
    }, this.props.filterData.searchKeyword , orderBy);

  }

  _onPageChange(activePage) {
    const {
      studentState,
      orderBy,
      filterData
    } = this.props;

    this.props.student.fetchStudent('after changing page @DefualtTab', studentState, { activePage }, filterData.searchKeyword, orderBy);
  }

  _onItemsCountPerPageChange(itemsCountPerPage) {
    const {
      studentState,
      orderBy,
      filterData
    } = this.props;

    this.props.student.fetchStudent('after changing items per page @DefualtTab', studentState, { itemsCountPerPage }, filterData.searchKeyword, orderBy);
  }

  isClassInfosExpanded(student) {
    return this.state.expandedClassInfos[student.schoolStudentID] == true;
  }

  expandClassInfos(student) {
    let { expandedClassInfos } = this.state;

    //
    // expand the collapsed class info
    // TODO: should we refactor it as more explicit method inside the TabComponent?
    //
    this.setState({
      expandedClassInfos: {
        ...expandedClassInfos,
        [student.schoolStudentID]: true
      }
    });
  }

  collapseRows({ trIndex, tbodyData }) {
    if (!tbodyData) {
      return;
    }
    const student = tbodyData[0];
    return this.isClassInfosExpanded(student) || (trIndex < SHOW_CLASSES_UPTO_NUMBER_OF);
  }

  //
  // Insert a "refund" button when there is refundable class
  //
  _settingsModifier(settings, { trData: student }) {
    //
    // we can assume that we want to refund anytime for now
    //
    let showRefund = true;

    //
    // Later we might want to add 'refund' button conditionally,
    //
    // if (Array.isArray(student.list)) {
    //  student.list.map((cls)=>{
    //   ...do some conditional stuff
    //  });
    // }
    //
    if (!showRefund || !settings[2]) {
      return settings;
    }

    settings[2].dropdown.splice(2, 0, {
      title: __('Refund', 'student'),
      onClick: this.refund,
    });

    return settings;
  }

  _onTrSelectionToggled({ selected }) {
    this.props.student.updateSelectedStudents('selected students updated @ DefaultTab', selected);
  }

	render() {
    let {
      studentList,
      studentState,
      fetching,
      currentCount,
      pagination,
      studentSelectedByCheckbox,
      school_has_student,
    } = this.props.student;

    // we show onBoarding content in the following scenario
    // 1. The server is not fetching. We want to use fetched info not, default currentCount value 0.
    // 2. OnBoarding content is actually not empty
    // 3. currentCount is 0
    const content = onBoardingContents[studentState] || {};

    if (studentList.length == 0 && fetching == true && !content) {
      return <div />
    }

    if (school_has_student == false && content && fetching !== true) {
      return (
        <OnBoardingNatural
          isShown={true}
          showArrow={content.showArrow}
          title={content.title}
          text={content.text}
          image={content.image}
        />
      );
    }

		return (
      <div className='default-tab'>
        <StudentTable
          data={studentList}
          fetching={fetching}
          settings={this.tableSettings}
          fields={this.studentFields}
          trFilter={this.collapseRows}
          settingsModifier={this._settingsModifier}
          onTrSelectionToggled={this._onTrSelectionToggled}
          useMultiSelection={studentState !== 'archived'}
          studentSelectedByCheckbox={studentSelectedByCheckbox}

          pagination={pagination}
          usePagination={true}
          onPageChange={this._onPageChange}
          onItemsCountPerPageChange={this._onItemsCountPerPageChange}

          {...this.props}
        />
      </div>
    )
  }
}

export default hotline(DefaultTab, 'user', 'student', 'schoolDetail');



// WEBPACK FOOTER //
// ./src/containers/pages/Student/DefaultTab.js